import React from "react";
import { Box } from "@chakra-ui/react";
import { Section, sectionSpacingY } from "components/section";
import { TextTitle } from "ui/text";
import { desktopOnlyDisplay, mobileOnlyDisplay } from "utils";
import { ComparisonsTable } from "./comparison-table";
import { ComparisonsAccordion } from "./comparison-accordion";

export function AidComparisonTable() {
  return (
    <Section my={0} py={sectionSpacingY}>
      <TextTitle display={mobileOnlyDisplay()} size="md" title="Discover the AI that fits your use case" titleAs="h3" />

      <Box display={mobileOnlyDisplay()} mt="small">
        <ComparisonsAccordion />
      </Box>

      <Box display={desktopOnlyDisplay()}>
        <ComparisonsTable />
      </Box>
    </Section>
  );
}
